// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ShippingAddress-module-messageBox-dwxok{margin-bottom:24px}.ShippingAddress-module-bottomAction-2cYUA{display:grid;-webkit-margin-before:20px;margin-block-start:20px;-webkit-margin-before:var(--spacing-sm, 20px);margin-block-start:var(--spacing-sm, 20px);width:-webkit-fit-content;width:fit-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageBox": "ShippingAddress-module-messageBox-dwxok",
	"bottomAction": "ShippingAddress-module-bottomAction-2cYUA"
};
export default ___CSS_LOADER_EXPORT___;
